module.exports = __webpack_public_path__ + "static/media/guest_approved@2x.13d0e8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/guest_approved@2x.png
// module id = 1004
// module chunks = 40